import { RouteRecordRaw } from 'vue-router'

import { UserGroup } from '@generated/types'

export const venueUiRoutes: RouteRecordRaw[] = [
  {
    path: '/venue/playground',
    name: 'playground',
    component: () => import('@/modules/playground/pages/PlaygroundDefault.vue'),
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Floor Plans',
    },
  },
  {
    path: '/venue/dashboard',
    redirect: { name: 'reservationsDashboardLive' },
  },
  {
    path: '/venue/dashboard-live',
    name: 'reservationsDashboardLive',
    component: () => import('@/modules/dashboard/pages/DashboardLive.vue'),
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Dashboard',
    },
  },
  {
    path: '/venue/accounting-summary',
    name: 'accountingSummary',
    component: () => import('@/pages/venue/AccountingSummary.vue'),
    meta: {
      requiresAuth: UserGroup.OWNERS,
      pageTitle: 'Accounting Summary',
    },
  },
  {
    path: '/venue/guest/:id',
    name: 'guest',
    component: () => import('@/pages/venue/GuestDetail.vue'),
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Guest Detail',
    },
  },
  {
    path: '/venue/style-guide',
    name: 'styleguide',
    component: () => import('@/pages/venue/StyleGuide.vue'),
    meta: {
      requiresAuth: UserGroup.MANAGERS,
      pageTitle: 'Style Guide',
    },
  },
]
